import HailIcon from "@mui/icons-material/Hail";
import TokenIcon from "@mui/icons-material/Token";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import BackspaceIcon from "@mui/icons-material/Backspace";
import FastRewindIcon from "@mui/icons-material/FastRewind";
import RoomServiceIcon from "@mui/icons-material/RoomService";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import DoNotDisturbOffIcon from "@mui/icons-material/DoNotDisturbOff";
import SportsMotorsportsIcon from "@mui/icons-material/SportsMotorsports";
import AssignmentReturnedIcon from "@mui/icons-material/AssignmentReturned";
import { getStatusNumberColor } from "../utils/orders";

export const getStatusIcon = (key) => {
  switch (key) {
    case "Aguardando Aprovação":
      return <HourglassTopIcon fontSize="inherit" />;

    case "Confirmação enviada":
      return <DoneAllIcon fontSize="inherit" />;

    case "Confirmado":
      return <DoneAllIcon fontSize="inherit" />;

    case "Aguardando confirmação de despache":
      return <DeliveryDiningIcon fontSize="inherit" />;

    case "A caminho":
      return <DeliveryDiningIcon fontSize="inherit" />;

    case "Em preparo":
      return <RoomServiceIcon fontSize="inherit" />;

    case "Aguardando confirmação de Pronto":
      return <HailIcon fontSize="inherit" />;

    case "Pronto para retirada":
      return <HailIcon fontSize="inherit" />;

    case "Finalizado":
      return <DoneAllIcon fontSize="inherit" />;

    case "Cancelamento Solicitado":
      return <BackspaceIcon fontSize="inherit" />;

    case "Aguardando cancelamento":
      return <BackspaceIcon fontSize="inherit" />;

    case "Aguardando cancelamento aceito":
      return <BackspaceIcon fontSize="inherit" />;

    case "Aguardando cancelamento rejeitado":
      return <DoNotDisturbOffIcon fontSize="inherit" />;

    case "Cancelado":
      return <BackspaceIcon fontSize="inherit" />;

    default:
      return <HourglassTopIcon fontSize="inherit" />;
  }
};

export const getStatusNumberIcon = (key) => {
  switch (key) {
    case 0:
      return (
        <HourglassTopIcon
          fontSize="inherit"
          htmlColor={getStatusNumberColor(key)}
        />
      );

    case 1:
      return (
        <DoneAllIcon fontSize="inherit" htmlColor={getStatusNumberColor(key)} />
      );

    case 2:
      return (
        <DoneAllIcon fontSize="inherit" htmlColor={getStatusNumberColor(key)} />
      );

    case 3:
      return (
        <DeliveryDiningIcon
          fontSize="inherit"
          htmlColor={getStatusNumberColor(key)}
        />
      );

    case 5:
      return (
        <DeliveryDiningIcon
          fontSize="inherit"
          htmlColor={getStatusNumberColor(key)}
        />
      );

    case 7:
      return (
        <TokenIcon fontSize="inherit" htmlColor={getStatusNumberColor(key)} />
      );

    case 8:
      return (
        <RoomServiceIcon
          fontSize="inherit"
          htmlColor={getStatusNumberColor(key)}
        />
      );

    case 10:
      return (
        <TravelExploreIcon
          fontSize="inherit"
          htmlColor={getStatusNumberColor(key)}
        />
      );

    case 13:
      return (
        <HailIcon fontSize="inherit" htmlColor={getStatusNumberColor(key)} />
      );

    case 15:
      return (
        <SportsMotorsportsIcon
          fontSize="inherit"
          htmlColor={getStatusNumberColor(key)}
        />
      );

    case 21:
      return (
        <HailIcon fontSize="inherit" htmlColor={getStatusNumberColor(key)} />
      );

    case 27:
      return (
        <DoneAllIcon fontSize="inherit" htmlColor={getStatusNumberColor(key)} />
      );

    case 34:
      return (
        <DoneAllIcon fontSize="inherit" htmlColor={getStatusNumberColor(key)} />
      );

    case 44:
      return (
        <SportsMotorsportsIcon
          fontSize="inherit"
          htmlColor={getStatusNumberColor(key)}
        />
      );

    case 55:
      return (
        <BackspaceIcon
          fontSize="inherit"
          htmlColor={getStatusNumberColor(key)}
        />
      );

    case 89:
      return (
        <BackspaceIcon
          fontSize="inherit"
          htmlColor={getStatusNumberColor(key)}
        />
      );

    case 144:
      return (
        <BackspaceIcon
          fontSize="inherit"
          htmlColor={getStatusNumberColor(key)}
        />
      );

    case 233:
      return (
        <DoNotDisturbOffIcon
          fontSize="inherit"
          htmlColor={getStatusNumberColor(key)}
        />
      );

    case 377:
      return (
        <BackspaceIcon
          fontSize="inherit"
          htmlColor={getStatusNumberColor(key)}
        />
      );

    case 610:
      return (
        <FastRewindIcon
          fontSize="inherit"
          htmlColor={getStatusNumberColor(key)}
        />
      );

    case 987:
      return (
        <AssignmentReturnedIcon
          fontSize="inherit"
          htmlColor={getStatusNumberColor(key)}
        />
      );

    default:
      return (
        <HourglassTopIcon
          fontSize="inherit"
          htmlColor={getStatusNumberColor(key)}
        />
      );
  }
};

export const getBackgroundColorStatusNumber = (key) => {
  switch (key) {
    case 0:
      return "label_bg__icon--grey";

    case 1:
      return "label_bg__icon--grey";

    case 2:
      return "label_bg__icon--green";

    case 3:
      return "label_bg__icon--grey";

    case 5:
      return "label_bg--going";

    case 8:
      return "label_bg--start";

    case 10:
      return "label_bg__icon--grey";

    case 13:
      return "label_bg__icon--grey";

    case 15:
      return "label_bg--going";

    case 21:
      return "label_bg--ready";

    case 34:
      return "label_bg--finish";

    case 55:
      return "label_bg__icon--grey";

    case 89:
      return "label_bg__icon--grey";

    case 144:
      return "label_bg__icon--grey";

    case 233:
      return "label_bg__icon--grey";

    case 377:
      return "label_bg--cancel";

    case 610:
      return "label_bg__icon--grey";

    case 987:
      return "label_bg--cancel";

    default:
      return "label_bg__icon--grey";
  }
};

export const statusNumberToStatusText = (statusNumber) => {
  switch (statusNumber) {
    case 0:
      return "Aguardando Aprovação";
    case 1:
      return "Confirmação enviada";
    case 2:
      return "Confirmado";
    case 3:
      return "Aguardando confirmação de despache";
    case 5:
      return "A caminho";
    case 8:
      return "Em preparo";
    case 10:
      return "Procurando Entregador";
    case 13:
      return "Aguardando confirmação de Pronto";
    case 15:
      return "Entregador A Caminho";
    case 21:
      return "Pronto para retirada";
    case 27:
      return "Aguardando Confirmação de Conclusão";
    case 34:
      return "Finalizado";
    case 55:
      return "Cancelamento Solicitado";
    case 89:
      return "Aguardando cancelamento";
    case 144:
      return "Aguardando cancelamento aceito";
    case 233:
      return "Aguardando cancelamento rejeitado";
    case 377:
      return "Cancelado";
    case 610:
      return "Retornando";
    case 987:
      return "Devolvido";
    default:
      return statusNumber;
  }
};
